var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echartsRadar"},[_c('div',{ref:"echartsRadarIn",staticClass:"echartsRadarIn"}),(!_vm.echartClick)?_c('div',{staticClass:"echartsRadarNum"},[_c('div',{staticClass:"echartsRadarNumFen"},[_vm._v(_vm._s(_vm.runAverage))]),_c('div',{staticClass:"echartsRadarNumName"},[_vm._v("综合得分")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }